import React from 'react';
import { Formik } from 'formik';

import AuthForm from '../../containers/AuthForm/AuthForm';
import FieldSet from '../../components/FieldSet/FieldSet';
import TextField from '../../../../components/TextField/TextField';
import ResetPasswordModal from '../../components/ResetPasswordModal/ResetPasswordModal';

import { users } from '../../../../utils/api';
import styles from './ResetPassword.module.css';
import useScrollLock from '../../../../hooks/use-scroll-lock';
import { ResetPasswordSchema } from '../../../../utils/validations';

// Ссылка открывает чат с ботом в приложении «Ателеком»
const BOT_LINK = 'atlkm://bot/sigur_bot';

function ResetPassword() {
  const initialValues = {
    email: '',
  };
  const { targetRef, targetElement, enableBodyScroll } = useScrollLock();
  const enableScroll = () => enableBodyScroll(targetElement);

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  function handleClick() {
    setIsModalOpen(!isModalOpen);
    enableScroll();
  }

  function handleSubmit({ email }, actions) {
    users
      .password()
      .reset({ email })
      .then(() => {
        setIsModalOpen(true);
        actions.resetForm();
      })
      .catch(({ response }) => {
        const errors = response?.data?.email || [{ detail: 'Не удалось отправить запрос. Попробуйте позже' }];

        actions.setFieldError('email', errors[0].detail);
      })
      .finally(() => actions.setSubmitting(false));
  }

  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={ResetPasswordSchema}
        onSubmit={(values, actions) => handleSubmit(values, actions)}
        render={({ touched, errors, setFieldValue, handleBlur, isSubmitting }) => (
          <AuthForm
            title="Не можете войти в систему?"
            btnText="Отправить"
            isSubmitting={isSubmitting}
          >
            <p className={styles.text}>Пароль восстанавливается через мессенджер «Ателеком»:</p>

            <ol className={styles.steps}>
              <li>
                Откройте «Ателеком» и найдите бота <b>«Сигур ПО СКУД»</b>.
              </li>
              <li>
                Напишите ему: <b>сбросить пароль</b>
              </li>
              <li>Бот пришлёт ссылку — откройте её.</li>
              <li>
                Придумайте новый пароль: не короче 8 символов, латинские буквы и цифры. Сохраните.
              </li>
              <li>Войдите в CRM со своим email и новым паролем.</li>
            </ol>

            <a className={styles['bot-link']} href={BOT_LINK}>
              Открыть бота в «Ателекоме»
            </a>

            <p className={styles.note}>
              Бот находит вас по логину в мессенджере: он должен совпадать с частью корпоративного email
              до «@» (ivanov для ivanov@nipt.ru). Если бот вас не нашёл или у вас не корпоративный
              email — обратитесь к администратору CRM, он сбросит пароль.
            </p>

            <p className={styles.text}>
              Если вы уже писали боту раньше, ссылку можно запросить и здесь:
            </p>

            <FieldSet label="Email" className={styles.fieldset}>
              <TextField
                name="email"
                type="email"
                setFieldValue={setFieldValue}
                handleBlur={handleBlur}
                removeSpacesOnBlur
                error={touched.email && errors.email}
              />
            </FieldSet>
          </AuthForm>
        )}
      />

      <ResetPasswordModal
        isOpen={isModalOpen}
        onClose={handleClick}
        ref={targetRef}
        target={targetElement}
      />
    </>
  );
}

export default ResetPassword;
